/**
 * O selo de situação de um título — compartilhado pela listagem e pela gaveta.
 *
 * Existe como componente porque as duas telas mostram a MESMA situação, e um
 * selo escrito duas vezes é como "Atrasada" fica vermelha numa e âmbar na
 * outra. A cor sai do `Selo` (`componentes/Selo.tsx`), no formato do catálogo.
 *
 * A regra de cor é a da spec 01, e é dura: desfecho normal é NEUTRO, âmbar é o
 * que espera alguém hoje, vermelho é o que travou. Por isso "Recebida" e
 * "Paga" — que são o final feliz e a maioria das linhas de um mês fechado —
 * ficam cinza: verde em quase toda linha não classificaria nada.
 *
 * A frase de apoio que acompanha o selo ("3 dias de atraso", "no prazo") vive
 * em `plataforma/financeiro.ts`, junto de `razaoDeImutabilidade`: é texto
 * derivado do domínio, não desenho.
 */
import { Selo } from '../../componentes/Selo'
import { urgenciaDaConta, type Lado, type LinhaConta } from '../../plataforma/financeiro'

export function SeloDaConta({ lado, linha }: { lado: Lado; linha: LinhaConta }) {
  const urgencia = urgenciaDaConta(linha)

  if (urgencia === 'cancelada') return <Selo tom="riscado">Cancelada</Selo>
  if (urgencia === 'quitada') {
    return <Selo tom="neutro">{lado === 'receber' ? 'Recebida' : 'Paga'}</Selo>
  }
  if (urgencia === 'atrasada') return <Selo tom="erro">Atrasada</Selo>
  if (urgencia === 'vence_hoje') return <Selo tom="atencao">Vence hoje</Selo>
  return <Selo tom="neutro">Em aberto</Selo>
}
